import SvgIcon from 'components/helpers/SvgIcon/SvgIcon';
import { RefinementList, RefinementListProps } from 'react-instantsearch-hooks-web';
import { classnames } from 'tailwindcss-classnames';
import StateCurrentRefinements from './StateCurrentRefinements';
import { StateName } from 'components/helpers/NmdpSite/TCDirectorySearch/_states';
import { useSearchDictionary } from 'components/helpers/AlgoliaSearch/util';

// Had to move this out of the component due to an infinite loop bug similar to this one: https://github.com/algolia/instantsearch.js/issues/1990
const transformItems: RefinementListProps['transformItems'] = (items) => {
  return items.map((item) => ({
    ...item,
    label: StateName(item.value) as string,
  }));
};

const StateFacet = () => {
  const dict = useSearchDictionary();

  return (
    <div className={classnames('md:flex', 'flex-row')}>
      <div className={classnames('my-4')}>
        <div className={classnames('mb-0.5')}>
          <span className={classnames('text-solidBlack', 'text-base', 'font-semibold', 'mr-1')}>
            {dict.state}
          </span>
          <span className={classnames('text-gray-darkGray', 'text-base', 'font-regular')}>
            {dict.optional}
          </span>
        </div>
        <details className={classnames('relative', 'md:mr-10')}>
          <summary
            className={classnames(
              'relative',
              'bg-white',
              'border',
              'border-gray-spunPearl',
              'rounded-md',
              'p-2',
              'w-full',
              'flex',
              'items-center',
              'justify-between'
            )}
          >
            <span>Select</span>
            <span>
              <SvgIcon
                icon="chevron-down"
                size="xs"
                viewBoxSize="0 0 24 24"
                className={classnames('mr-2')}
              />
            </span>
          </summary>
          <div
            className={classnames(
              'absolute',
              'z-20',
              'p-6',
              'bg-white',
              'border',
              'border-gray-spunPearl',
              'rounded-md',
              'p-2',
              'w-full',
              'max-h-60',
              'overflow-y-scroll'
            )}
          >
            <RefinementList
              transformItems={transformItems}
              attribute="state"
              limit={50}
              sortBy={['name:asc']}
            />
          </div>
        </details>
        <div className={classnames('text-gray-darkGray', 'text-sm', 'font-regular', 'p-1')}>
          Select as many states as you want
        </div>
      </div>
      <div className={classnames('md:mt-10', 'mb-5')}>
        <StateCurrentRefinements includedAttributes={['state']} />
      </div>
    </div>
  );
};

export default StateFacet;
